import {
    BancontactPayment,
    Cheque,
    CreditCardBack,
    IdealPayment,
    Money,
    PaypalPayment,
    Receipt,
    SepaPayment,
    SofortPayment,
} from '@eventbrite/eds-iconography';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React, { ReactNode } from 'react';
import { PaymentMethod } from './paymentMethod';

export interface PaymentMethodInfo {
    userString: string | GenericLazyString;
    icon: ReactNode;
}

// Payment methods for which we don't want to display a name or icon to the user
const SILENT_PAYMENT_METHODS = [PaymentMethod.StripeConfirmationToken];

export const PAYMENT_METHODS_INFO: Record<
    Exclude<
        PaymentMethod,
        | PaymentMethod.NotSelected
        | PaymentMethod.UserInstrument
        | typeof SILENT_PAYMENT_METHODS[number]
    >,
    PaymentMethodInfo
> = {
    [PaymentMethod.Credit]: {
        userString: gettext('Credit or Debit Card'),
        icon: <CreditCardBack />,
    },
    [PaymentMethod.Ideal]: {
        userString: gettext('iDEAL'),
        icon: <IdealPayment />,
    },
    [PaymentMethod.MaestroBancontact]: {
        userString: gettext('Bancontact'),
        icon: <BancontactPayment />,
    },
    [PaymentMethod.Sofort]: {
        userString: gettext('Sofort'),
        icon: <SofortPayment />,
    },
    [PaymentMethod.NonceBraintree]: {
        userString: gettext('PayPal'),
        icon: <PaypalPayment />,
    },
    [PaymentMethod.SepaDirectDebit]: {
        userString: gettext('Sepa Direct Debit'),
        icon: <SepaPayment />,
    },
    [PaymentMethod.Cash]: {
        userString: gettext('Pay at the door'),
        icon: <Money />,
    },
    [PaymentMethod.Invoice]: {
        userString: gettext('Pay by invoice'),
        icon: <Receipt />,
    },
    [PaymentMethod.Check]: {
        userString: gettext('Pay by check'),
        icon: <Cheque />,
    },
    [PaymentMethod.FPPPaypal]: {
        userString: gettext('PayPal'),
        icon: <PaypalPayment />,
    },
};
